import { FC, useState } from "react";
import {
  MuiBox,
  MuiButtonPrimary,
  MuiButtonSecondary,
} from "../../../../components";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { CancelFieldModal } from "../../../createProgramTemplate/components/cancelFieldModal/CancelFieldModal";
import { CPEditParticipantFooterWrapper } from "./CPEditParticipantFooter.style";

interface CPEditParticipantFooterProps {
  pageId: string;
  handleNavigateBack: () => void;
  onConfirmClick: () => void;
  confirmationTitle?: string;
  cancelButtonText?: string;
  cancelMessage?: string;
}

export const CPEditParticipantFooter: FC<CPEditParticipantFooterProps> = ({
  pageId,
  handleNavigateBack,
  cancelButtonText,
  confirmationTitle,
  cancelMessage,
  onConfirmClick,
}) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { commonLabels } = useSiteCore();

  const handleModalClose = () => {
    setShowCancelModal(false);
  };

  const handleOkClick = () => {
    handleModalClose();
    handleNavigateBack();
  };
  return (
    <CPEditParticipantFooterWrapper>
      <MuiBox className="button-group">
        <MuiButtonSecondary
          data-testid={COMPONENT_IDS.CLOSE_BUTTON}
          id={`${pageId}-cancel`}
          onClick={handleNavigateBack}
        >
          {cancelButtonText ?? commonLabels.cancel}
        </MuiButtonSecondary>
        <MuiButtonPrimary
          data-testid={COMPONENT_IDS.UPDATE_BUTTON}
          onClick={onConfirmClick}
          id={`${pageId}-confirm`}
        >
          {commonLabels.update}
        </MuiButtonPrimary>
      </MuiBox>
      {showCancelModal && (
        <CancelFieldModal
          showModal={showCancelModal}
          handleModalClose={handleModalClose}
          handlePrimaryButtonClick={handleOkClick}
          cancelMessage={cancelMessage}
          title={confirmationTitle}
        />
      )}
    </CPEditParticipantFooterWrapper>
  );
};
